import React, { useEffect, Fragment } from 'react';
import Link from 'next/link';
import { isEmpty } from 'lodash';
import { deviceType } from 'react-device-detect';
import { Box, Flex, Text, Image, Avatar, Link as LinkChakra, SimpleGrid, useColorMode } from '@chakra-ui/react';
import { Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody } from '@chakra-ui/react';
import { Container } from 'components/Container';
import { formatPercent } from 'utils/utility';
import { FaUser } from 'react-icons/fa';
import { truncate, validURL } from 'lib/utility';
import HistorySection from './HistorySection';
import RecentBids from './RecentBids';
import Unlockable from './Unlockable';
import { bgColor } from 'config/data';

const NftInformation = ({ nftData, collection, bids, history, currentUser, unlockables }) => {
  // console.log('unlockables', unlockables);
  const { nft } = nftData;
  const {
    description,
    user,
    attributes,
    non_fungible_token_collection,
    auction,
    minter,
    edition,
    non_fungible_token_collection_index,
  } = nft;
  const { colorMode } = useColorMode();

  // console.log('currentUser', currentUser);

  // console.log('non_fungible_token_collection_index', non_fungible_token_collection_index);

  const non_fungible_token_collection_id = non_fungible_token_collection?.id;
  // console.log('attributes', attributes);
  // const atributos = !isEmpty(attributes) ? JSON.parse(attributes) : {};
  // const atributos = Array.isArray(attributes) ? attributes.map((i) => ({ name: i.trait_type, value: i.value })) : JSON.parse(attributes);
  // const atributos = isEmpty(attributes) ? {} : Array.isArray(attributes) ? attributes.map((i) => ({ name: i.name, value: i.value })) : JSON.parse(attributes);
  // const atributos = JSON.parse(attributes);
  // const atributos = Array.isArray(attributes) ? attributes.map((i) => ({ name: i.name, value: i.value })) : JSON.parse(attributes);
  const atributos = !isEmpty(attributes) ? attributes : [];

  const attributes_count = isEmpty(collection?.attributes_count) ? {} : collection?.attributes_count;
  const non_fungible_tokens_count = collection?.non_fungible_tokens_count || 0;

  const [device, setDevice] = React.useState('');

  const nameAvatar = `${user?.username}`;
  const userLink = `/${user?.username}`;
  const isUrl = validURL(description);

  useEffect(() => {
    setDevice(deviceType);
  }, []);

  return (
    <Box
      bg={colorMode === 'light' ? '#f9f9f9' : null}
      as="section"
      id="nft_info"
      py={{ base: '25px', md: '30px' }}
      px={['15px', '10px', 0]}
    >
      <Container>
        <Flex w={{ base: '100%', md: '840px' }} id="nft" m="0 auto" flexDirection={{ base: 'column', md: 'row' }}>
          <Flex flex="1" flexDirection="column" pr={{ base: 0, md: '60px' }}>
            {currentUser?.id === user?.id && !isEmpty(unlockables) && <Unlockable unlockables={unlockables} />}

            {auction && !isEmpty(bids) && device === 'mobile' && <RecentBids bids={bids} />}
            <Text fontWeight="bold" mb="20px">
              Information
            </Text>
            <Flex
              id="box"
              bg={bgColor[colorMode]}
              boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)"
              p={{ base: '22px 12px', md: '25px 20px' }}
              justifyContent="space-between"
              borderRadius={4}
              mb="30px"
            >
              <Flex id="owner" flex="1">
                <Flex pos="relative" id="avatar">
                  <Avatar
                    name={nameAvatar}
                    bg="#7A8087"
                    color="#fff"
                    icon={<FaUser fontSize="1.1rem" color="#ececec" />}
                    mr="10px"
                    w={{ base: '35px', md: '54px' }}
                    h={{ base: '35px', md: '54px' }}
                  />
                  {user?.is_verified && (
                    <Image
                      pos="absolute"
                      bottom="3px"
                      right="3px"
                      w="24px"
                      h="24px"
                      src="/images/icon-verified-icon.svg"
                      alt=""
                    />
                  )}
                </Flex>

                <Flex id="owner_info" fontSize="12px" flexDirection="column">
                  <Text>Owner</Text>
                  <Link href={userLink}>
                    <a>
                      <Flex alignItems="center">
                        <Text fontWeight="bold" fontSize="14px">
                          {nameAvatar}
                        </Text>
                        {user?.country?.iso_alpha_2 && (
                          <Image
                            src={`https://flagcdn.com/16x12/${user?.country?.iso_alpha_2.toLocaleLowerCase()}.png`}
                            alt=""
                            ml="10px"
                            alignSelf="center"
                          />
                        )}
                      </Flex>
                    </a>
                  </Link>
                </Flex>
              </Flex>
            </Flex>

            {description && (
              <>
                <Text fontWeight="bold" mb="20px">
                  Art Description
                </Text>
                <Flex
                  id="box"
                  bg={bgColor[colorMode]}
                  boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)"
                  p={{ base: '22px 12px', md: '25px 20px' }}
                  justifyContent="space-between"
                  borderRadius={4}
                  mb="30px"
                >
                  {isUrl ? (
                    <LinkChakra href={description} color="blue.500" target="_blank">
                      {description}
                    </LinkChakra>
                  ) : (
                    <Text>{description}</Text>
                  )}
                </Flex>
              </>
            )}

            {non_fungible_token_collection_id && isEmpty(edition) && (
              <>
                <Text fontWeight="bold" mb="20px">
                  Collection
                </Text>
                <Flex
                  id="box"
                  bg={bgColor[colorMode]}
                  boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)"
                  p={{ base: '22px 12px', md: '25px 20px' }}
                  borderRadius={4}
                  mb="30px"
                >
                  <Text fontSize="42px" fontWeight="bold" ml="20px">
                    {non_fungible_token_collection_index || 1}
                    <Text as="span" fontSize="24px" ml="10px" fontWeight="400">
                      of {non_fungible_tokens_count}
                    </Text>
                  </Text>
                </Flex>
              </>
            )}
            {!isEmpty(atributos) && (
              <>
                <Text fontWeight="bold" mb="20px">
                  Attributes
                </Text>
                <Flex
                  id="box"
                  bg={bgColor[colorMode]}
                  boxShadow="0 0 4px 0 rgba(0, 0, 0, 0.08)"
                  p={{ base: '22px 12px', md: '25px 20px' }}
                  justifyContent="flex-start"
                  borderRadius={4}
                  mb="30px"
                  flexWrap="wrap"
                >
                  <SimpleGrid columns={2} spacing="10px" w="100%">
                    {!isEmpty(atributos) &&
                      atributos.map((i, idx) => {
                        const hasValue =
                          (i.hasOwnProperty('name') && i.hasOwnProperty('value')) ||
                          (i.hasOwnProperty('trait_type') && i.hasOwnProperty('value'));
                        // const hasNewValue = i.hasOwnProperty('trait_type') ;
                        const obj = Object.entries(i);
                        const val = obj[0];
                        const value = hasValue ? i.value : isEmpty(val[1]) ? null : val[1];
                        const values = attributes_count[hasValue ? i.name || i.trait_type : val[0]];
                        const count = values ? attributes_count[hasValue ? i.name || i.trait_type : val[0]][value] : 0;
                        const rarity = (count * 100) / non_fungible_tokens_count;
                        return (
                          <Fragment key={idx}>
                            {value !== null && (
                              <Flex
                                bg={colorMode === 'dark' ? '#141414' : '#f7f7f7'}
                                borderRadius="12px"
                                // mr="15px"
                                mb="10px"
                                borderWidth={colorMode === 'dark' ? 0 : 1}
                                p="13px 11px"
                                flexDirection="column"
                                w="100%"
                              >
                                <Text fontSize="11px" fontWeight="500" textTransform="uppercase" id="label">
                                  {hasValue ? i.name || i.trait_type : val[0]}
                                </Text>
                                {value?.length > 18 ? (
                                  <Popover placement="top-start" trigger="hover">
                                    <PopoverTrigger>
                                      <Text
                                        fontSize="14px"
                                        fontWeight="bold"
                                        textTransform="uppercase"
                                        mt="1px"
                                        id="value"
                                      >
                                        {truncate(hasValue ? i.value : val[1], 18)}
                                      </Text>
                                    </PopoverTrigger>
                                    <PopoverContent>
                                      <PopoverArrow />
                                      <PopoverBody fontSize="13px" color="gray.600">
                                        {hasValue ? i.value : val[1]}
                                      </PopoverBody>
                                    </PopoverContent>
                                  </Popover>
                                ) : (
                                  <Text fontSize="14px" fontWeight="bold" textTransform="uppercase" mt="1px" id="value">
                                    {truncate(hasValue ? i.value : val[1], 18)}
                                  </Text>
                                )}

                                {values && (
                                  <Text fontSize="13px" fontWeight="medium" mt="5px" color="#161616">
                                    {formatPercent(rarity)} {rarity <= 1 && `💎`} {rarity > 1 && rarity <= 5 && `🔥`}
                                    {rarity > 5 && rarity <= 10 && `👀`}
                                  </Text>
                                )}
                              </Flex>
                            )}
                          </Fragment>
                        );
                      })}
                  </SimpleGrid>
                </Flex>
              </>
            )}
          </Flex>
          <Flex flex="1" flexDirection="column">
            {auction && !isEmpty(bids) && device !== 'mobile' && <RecentBids bids={bids} />}
            {!isEmpty(history) && <HistorySection history={history} minter={minter} />}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};
export default NftInformation;
